function getQueryStringArgs() {
    var args = {}, parts = (window.location && location.search || "").substr(1).split(/&/g);

    for (var i = 0; i < parts.length; i++) {
        var pair = parts[i].split(/=/, 2);
        args[pair[0]] = pair[1] ? decodeURIComponent(pair[1].replace(/\+/g, " ")) : "";
    }

    return args;
}

var xamatron = {}, args = getQueryStringArgs();

xamatron.enabled = !!args.__xamatron;
xamatron.version = xamatron.enabled ? parseInt(args.__xamatronversion, 10) : null;
xamatron.platform = xamatron.enabled ? args.__xamatronplatform : "browser";

xamatron.initialNotification = null;

xamatron.ready = function (callback) {
    if (xamatron.enabled) {
        // TODO: purkka
        xamatron.bridge.addHandler("xamatron.ready", function (data) {
            xamatron.initialNotification = data.initialNotification;
            callback();
        });
    } else {
        callback();
    }
};

xamatron.openURL = function (url) {
    if (xamatron.enabled)
        xamatron.bridge.post("xamatron.openURL", { url: url });
    else
        window.open(url, "_blank", "");
};

xamatron.exitApplication = function () {
    if (xamatron.enabled)
        xamatron.bridge.post("xamatron.exitApplication");
    else
        alert("This would exit the application on the mobile device.");
};

var backButtonHandler = null;
xamatron.setBackButtonHandler = function (handler) {
    if (!xamatron.enabled)
        return;

    if (!backButtonHandler) {
        xamatron.bridge.addHandler("xamatron.backButton", function () {
            if (backButtonHandler != null)
                backButtonHandler();
        });
    }

    backButtonHandler = handler;
};

var remoteNotificationHandler = null;
xamatron.setRemoteNotificationHandler = function (handler) {
    if (!xamatron.enabled)
        return;

    if (!remoteNotificationHandler) {
        xamatron.bridge.addHandler("xamatron.remoteNotification", function (data) {
            if (remoteNotificationHandler != null)
                remoteNotificationHandler(data);
        });
    }

    remoteNotificationHandler = handler;
};

xamatron.registerForRemoteNotifications = function () {
    if (!xamatron.enabled)
        return;

    return xamatron.bridge.invoke("xamatron.registerForRemoteNotifications");
};

xamatron.getCurrentPosition = function (options) {
    if (!xamatron.enabled) {
        return new Promise(function (resolve, reject) {
            navigator.geolocation.getCurrentPosition(function (pos) {
                var c = pos.coords;

                resolve({
                    timestamp: pos.timestamp,
                    latitude: c.latitude,
                    longitude: c.longitude,
                    accuracy: c.accuracy,
                    altitude: c.altitude,
                    altitudeAccuracy: c.altitudeAccuracy,
                    heading: c.heading,
                    speed: c.speed
                });
            }, function (err) {
                reject({
                    code: err.code,
                    message: err.message,
                });
            }, options);
        });
    }

    return xamatron.bridge.invoke("xamatron.getCurrentPosition", { options: options });
};

if (xamatron.enabled) {
    var bridgeNextReqId = 1,
        bridgeRequestPromises = {},
        bridgeHandlers = {};

    window.handleScriptMessage = function (msg) {
        if (msg.reqId) {
            var promise = bridgeRequestPromises[msg.reqId];
            if (!promise)
                return;

            delete bridgeRequestPromises[msg.reqId];

            if (msg.data.result)
                promise.resolve(msg.data.result);
            else
                promise.reject(msg.data.error);
        } else if (msg.name) {
            var handlers = bridgeHandlers[msg.name];
            if (!handlers)
                return;

            for (var i = 0; i < handlers.length; i++)
                handlers[i](msg.data);
        }
    };

    xamatron.bridge = {
        invoke: function (name, data) {
            return new Promise(function (resolve, reject) {
                var reqId = bridgeNextReqId++;

                bridgeRequestPromises[reqId] = {
                    resolve: resolve,
                    reject: reject
                };

                postScriptMessage(JSON.stringify({
                    name: name,
                    reqId: reqId,
                    data: data
                }));
            });
        },

        post: function (name, data) {
            postScriptMessage(JSON.stringify({
                name: name,
                data: data
            }));
        },

        addHandler: function (name, handler) {
            var handlers = bridgeHandlers[name];
            if (!handlers)
                bridgeHandlers[name] = handlers = [];

            handlers.push(handler);
        }
    };
}

window.xamatron = xamatron;

export default xamatron;
